import React from "react";

import { average } from "utils/average";

type Props = {
  childRect: DOMRectReadOnly; //😅
  strainRect: DOMRectReadOnly; //😅
};

const StrainLineageOverlaySingleChild = ({ childRect, strainRect }: Props) => (
  <line
    id="centerChildDownLine"
    y1={strainRect.bottom + 5}
    y2={childRect.top - 5}
    x1={average([strainRect.right, strainRect.left])}
    x2={average([strainRect.right, strainRect.left])}
    stroke="currentColor"
    strokeWidth="2"
  />
);

export default StrainLineageOverlaySingleChild;
